import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

import { slideInTopOpenClose } from '@lockton-apps/shared/ui/lui';

@Component({
    selector: 'lockton-apps-slide-in-out-wrapper',
    templateUrl: './slide-in-out-wrapper.component.html',
    styleUrls: ['./slide-in-out-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideInTopOpenClose],
    standalone: false
})
export class SlideInOutWrapperComponent extends FieldWrapper {}
